import { useState, useEffect, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate, useLocation } from "react-router-dom";
import { getListUserAttendance, submitCheckinAttendance } from '../../../../../../api/repositories'
import { listUserAttendance } from "../constant";



const useActions = (valueSearch) => {
    const [ loadingListUser, setLoadingListUser ] = useState(true)
    const [ listDataUser, setListDataUser ] = useState([]);
    const [ loadingFetching, setLoadingFetching] = useState(true) // state loading only for fetch
    const [ dataAccomodate, setDataAccomodate ] = useState([]) // real data from API
    const [ userFullnameCheckin, setUserFullnameCheckin ] = useState();
    const [ sucUserFullname, setSucUserFullname ] = useState();
    const [ sucUserDateCheckin, setSucUserDateCheckin ] = useState();
    const [ useridCheckin, setUseridCheckin ] = useState();
    const [ statusCheckin, setStatusCheckin ] = useState();

    let location = useLocation()
    const path = location.pathname;
    const page = path.split('/');

    const fetchListUser = async(program_id) => {
        setLoadingListUser(true);
        setLoadingFetching(true)
    
        try {
            const { data, status } = await getListUserAttendance(program_id);
            // const { data, status } = listUserAttendance;
            
            if(status === 200){
                setListDataUser(data);
                setDataAccomodate(data);
            }
            
        } catch (err) {
            console.log("Error fetch List User Attendance "+err)
            setListDataUser([]);
            setDataAccomodate([]);
        } finally {
            setLoadingListUser(false)
            setLoadingFetching(false)
        }
    };

    const submitCheckinUser = async(userid) => {

        const payload = {
            program_id:parseInt(page[2]),
            user_id:userid
        }

        try {
            const { status, data } = await submitCheckinAttendance({data: payload});
            
            if(status === 200){
                setStatusCheckin("success");
                setSucUserFullname(data.fullname);
                setSucUserDateCheckin(data.date);
            } else {
                setStatusCheckin("failed");
                setSucUserFullname(undefined);
                setSucUserDateCheckin(undefined);
            }
            
        } catch (err) {
            console.log("Error Submit User Checkin "+err)
            setStatusCheckin("failed");
            setSucUserFullname(undefined);
            setSucUserDateCheckin(undefined);
        } finally {
            
        }
    }

    const filterSearching = (value, data) => {
        
        const trimResult = data.filter((e) => {
            const fullname = e.firstname+" "+e.lastname;
            if(fullname.toLowerCase().indexOf(value.toLowerCase()) > -1) return true
        })
        setListDataUser(trimResult)

        // console.log(trimResult)
        
        setLoadingListUser(false);
    }

    useEffect(() => {
        // refetch every change userid because fast pace
        fetchListUser(parseInt(page[2]))
    },[useridCheckin])

    useEffect(() => {
        if(loadingFetching === false){
            setLoadingListUser(true)
            const delayDebounceFn = setTimeout(() => {
                filterSearching(valueSearch, dataAccomodate);
            }, 800)
                
            return () => clearTimeout(delayDebounceFn)
        }
    },[valueSearch])
    
    return{
        loadingListUser,
        listDataUser,
        useridCheckin,
        setUseridCheckin,
        statusCheckin,
        submitCheckinUser,
        userFullnameCheckin,
        setUserFullnameCheckin,
        sucUserFullname,
        sucUserDateCheckin,
        setSucUserFullname,
        setSucUserDateCheckin,
        setStatusCheckin
    }
}

export default useActions